import { InvoicesStoreResponseDto } from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import {
  invoicesEndpoints,
  invoicesTags,
  GET_STORE_INVOICES_URL,
} from './config';

export const invoicesApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [invoicesTags.storeInvoices],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [invoicesEndpoints.getStoreInvoices]: builder.query<
        InvoicesStoreResponseDto,
        void
      >({
        query: () => ({
          method: 'GET',
          url: GET_STORE_INVOICES_URL,
        }),
        providesTags: [invoicesTags.storeInvoices],
      }),
    }),
  });

export const { useGetStoreInvoicesQuery } = invoicesApi;
